export default "__VITE_ASSET__UmI19SQu__";